import dashboardPT from './dashboard';
import menuAboutPT from './menuAbout';
import labelsPT from './labels';
import releasesPT from './releases';
import artistsPT from './artists';
import artistsWishlistPT from './artistsWishlist';
import profilePT from './profile';
import musicLinksPT from './musicLinks';
import linkLandingPagesPT from './linkLandingPages';
import masteringPT from './mastering';
import featurePT from './feature';
import accountingPT from './accounting';
import paymentMethodsPT from './paymentMethods';
import purchaseHistoryPT from './purchaseHistory';
import trendsPT from './trends';
import earningsDrilldownPT from './earningsDrilldown';
import invoicesPT from './invoices';
import statementsPT from './statements';
import subuserStatementsPT from './subuserStatements';
import userDataFormPT from './userDataForm';
import creditsPT from './credits';
import disputeClaimsPT from './disputeClaims';
import musicLinkUrlPartsPT from './musicLinkUrlParts';
import subscriptionPT from './subscription';
import twoFactorAuthPT from './twoFactorAuth';
import generalPT from './general';
import routerPT from './router';
import escrowWalletPT from './escrowWallet';
import subUsersPT from './subUsers';
import tokensPT from './tokens';
import tracksPT from './tracks';
import acrAlertPT from './acrAlert';
import qcNotePT from './qcNote';
import flaggedContentPT from './flaggedContent';
import deliveryConfirmationPT from './deliveryConfirmation';
import preScanPT from './preScan';
import accessKeysPT from './accessKeys';
import announcementsPT from './announcements';

const translationPT = {
    'router': routerPT,
    'general': generalPT,
    'dashboard': dashboardPT,
    'menuAbout': menuAboutPT,
    'labels': labelsPT,
    'artists': artistsPT,
    'artistsWishlist': artistsWishlistPT,
    'releases': releasesPT,
    'tracks': tracksPT,
    'profile': profilePT,
    'musicLinks': musicLinksPT,
    'musicLinkUrlParts': musicLinkUrlPartsPT,
    'linkLandingPages': linkLandingPagesPT,
    'mastering': masteringPT,
    'feature': featurePT,
    'accounting': accountingPT,
    'paymentMethods': paymentMethodsPT,
    'purchaseHistory': purchaseHistoryPT,
    'trends': trendsPT,
    'earningsDrilldown': earningsDrilldownPT,
    'invoices': invoicesPT,
    'statements': statementsPT,
    'subuserStatements': subuserStatementsPT,
    'credits': creditsPT,
    'userDataForm': userDataFormPT,
    'disputeClaims': disputeClaimsPT,
    'subscription': subscriptionPT,
    'twoFactorAuth': twoFactorAuthPT,
    'escrowWallet': escrowWalletPT,
    'subUsers': subUsersPT,
    'tokens': tokensPT,
    'acrAlert': acrAlertPT,
    'qcNote': qcNotePT,
    'flaggedContent': flaggedContentPT,
    'deliveryConfirmation': deliveryConfirmationPT,
    'preScan': preScanPT,
    'accessKeys': accessKeysPT,
    'announcements': announcementsPT,
};

export default translationPT;
